<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toastification" }, [
    _c(
      "div",
      { staticClass: "d-flex align-items-start" },
      [
        _c(
          "b-avatar",
          {
            staticClass: "mr-75 flex-shrink-0",
            attrs: { variant: _vm.variant, size: "1.8rem" },
          },
          [_c("feather-icon", { attrs: { icon: _vm.icon, size: "15" } })],
          1
        ),
        _c("div", { staticClass: "d-flex flex-grow-1" }, [
          _c("div", [
            _vm.title
              ? _c("h5", {
                  staticClass: "mb-0 font-weight-bolder toastification-title",
                  class: "text-" + _vm.variant,
                  domProps: { textContent: _vm._s(_vm.title) },
                })
              : _vm._e(),
            _vm.text
              ? _c("small", {
                  staticClass: "d-inline-block text-body",
                  domProps: { textContent: _vm._s(_vm.text) },
                })
              : _vm._e(),
          ]),
          _c(
            "span",
            {
              staticClass: "cursor-pointer toastification-close-icon ml-auto ",
              on: {
                click: function ($event) {
                  return _vm.$emit("close-toast")
                },
              },
            },
            [
              !_vm.hideClose
                ? _c("feather-icon", {
                    staticClass: "text-body",
                    attrs: { icon: "XIcon" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/toastification/ToastificationContent.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {
    BAvatar: bootstrapvue["BAvatar"]
  },
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: null
    },
    title: {
      type: [String, Object, Error],
      default: null
    },
    text: {
      type: [String, Object, Error],
      default: null
    },
    hideClose: {
      type: Boolean,
      default: false
    }
  }
});

//# sourceURL=webpack:///./src/@core/components/toastification/ToastificationContent.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}
.toastification-title {
  color: inherit;
}
</style>
